import { ChangeDetectorRef, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { FormSubscription } from 'app/shared/models/class/forms/form-definition';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { ThemePalette } from '@angular/material/core';
import { MatSort } from '@angular/material/sort';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { MatDialog } from '@angular/material/dialog';
import { FormService } from 'app/shared/services/forms/form.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';
import { OpenDialogDeleteElementComponent } from 'app/components/dialog/open-dialog-delete-element/open-dialog-delete-element.component';

@Component({
  selector: 'app-admin-subscriptions',
  templateUrl: './admin-subscriptions.component.html',
  styleUrls: ['./admin-subscriptions.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AdminSubscriptionsComponent extends SubscriptionBaseComponent implements OnInit {

  displayedColumns: string[] = ['createdOn', 'articleKey', 'username', 'email', 'city', 'phoneNumber', 'participantCount', 'details'];
  dataSource!: MatTableDataSource<FormSubscription>;
  valueInput = '';
  isLoading = false;
  searchForm!: UntypedFormGroup;
  subscriptions: FormSubscription[] = [];
  articleKey!: number;

  pageSize = 50;
  pageSizeOptions: number[] = [50, 100, 150];
  pageEvent!: PageEvent;
  color: ThemePalette = 'primary';

  @ViewChild(MatSort, { static: false }) sort!: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;

  constructor(
    private readonly faIconService: FaiconService,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly dialog: MatDialog,
    private readonly formService: FormService,
    private readonly uiService: UiService,
    private readonly _cdr: ChangeDetectorRef,
    private readonly route: ActivatedRoute,
    private readonly router: Router
  )
  {
    super();
    this.dataSource = new MatTableDataSource(this.subscriptions);
  }

  ngOnInit(): void {
    this.initForm();
    this.checkParameters();
    this.initSub();
  }

  applyFilter(filterValue: any): void {
    this.valueInput = filterValue;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  resetSearch(): void {
    this.searchForm.get('keyword')?.setValue('');
    this.valueInput = '';
    this.applyFilter(this.valueInput);
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  private checkParameters(): void {
    this.subscription.add(
      this.route.queryParams.subscribe(params => {
        this.articleKey = Number.parseInt(params['articleKey']);
        this.getSubscriptions(this.articleKey);
      })
    );
  }

  private initSub(): void {
    this.subscription.add(
      this.formService.isSubscriptionAdded$.subscribe((value: boolean) => {
        if (value) {
          this.getSubscriptions(this.articleKey);
        }
      })
    );
  }

  exportSubscriptions(): void {
    this.formService.getFormReportByArticleKey(this.articleKey).subscribe({
      next: () => {
        this.uiService.showSnackbar(`Export des souscriptions de l'article réussi.`);
      },
      error: () => {
        this.uiService.showSnackbar(`Erreur lors de l'export des souscriptions de l'article.`);
      }
    });
  }

  addForm(): void {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(
        ['/home/subscription-form'],
        {
          queryParams: {
            articleKey: this.articleKey.toString()
          }
        }
      )
    );

    window.open(url, '_blank');
  }

  edit(element: FormSubscription): void {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(
        ['/home/subscription-form'],
        {
          queryParams: {
            articleKey: this.articleKey.toString(),
            key: element.key?.toString()
          }
        }
      )
    );

    window.open(url, '_blank');
  }

  deleteFS(element: FormSubscription): void {
    const params = {
      disableClose: true,
      data: {
        title: `Suppression d'un formulaire `,
        text: `Êtes-vous sûr de vouloir supprimer cette souscription ?`,
        id: element.key,
        action: 'deleteSubscription'
      }
    };
    const dialogRef = this.dialog.open(OpenDialogDeleteElementComponent, params);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.subscriptions = this.subscriptions.filter(s => s.key !== element.key);
        this.initDataSource(this.subscriptions);
      }
    });
  }

  private initForm(): void {
    this.searchForm = this.formBuilder.group({
      keyword: ['']
    });
  }

  private getSubscriptions(articleKey: number): void {
    this.formService.getFormSubscription({ 'articleKey': articleKey }).subscribe({
      next: (subscriptions: FormSubscription[]) => {
        this.subscriptions = subscriptions;
        this.initDataSource(this.subscriptions);
      }
    });
  }

  private initDataSource(forms: FormSubscription[]): void {
    forms.forEach(f => {
      f.username = `${f.user.firstName} ${f.user.lastName}`;
      f.email = f.user.email;
      f.city = f.user.city;
      f.phoneNumber = f.user.phoneNumber;
      f.participantCount = f.user.participantCount;
    });
    this.dataSource = new MatTableDataSource(forms);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

}
